import moment from "moment";
import { widgetNames, TILE_ICON_BY_WIDGET_NAME } from "../constants/segmentTools";
import { ASSETS } from "./config";
import { sanitizeUserHtml } from "./sanitizeHtml";
import { prettifyWidgetName } from "./widgetLabel";
import { isSignedIn, readAuthStore } from "./loginRedirect";
import { hotbarSegmentSwatch } from "../components/NewHotbar/hotbarSegmentSwatch";
export const roundNumber = (number, decimalPlaces = 2) => {
  return Math.decimalPlaces(
    (number * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces)
  );
};
export const showDecimalPlaces = (number, decimalPlaces = 2) => {
  return number.toFixed(decimalPlaces);
};
export const numberToMinutes = (input) => {
  const roundedNumber = showDecimalPlaces(input);
  const [hour, minute] = roundedNumber.split(".");
  let seconds = minute * 36;
  const minutes = seconds > 60 ? Math.trunc(seconds / 60) : "00";
  seconds = seconds > 60 ? seconds % 60 : seconds || "00";
  return `${hour}:${minutes}`;
  // return `${hour}:${minutes}:${seconds}`
};
export const getDateString = () => {
  let date = new Date();
  return `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`;
};
export const getDegreeFromTime = (startTime, endTime) => {
  let dateString = getDateString();
  let startDate = moment(`${dateString} ${startTime}`);
  let endDate = moment(`${dateString} ${endTime}`);
  let minuteDiffrence = Math.abs(endDate.diff(startDate, "minutes"));
  return minuteDiffrence * 0.069; //1 min is 0.38 degree
};

export const calculateOffset = (endTime) => {
  let dateString = getDateString();
  let startDate = moment(`${dateString} ${endTime}`);
  return (startDate.hour() * 60 + startDate.minute()) * 0.25; //+ 360
};

export const getPrevAndNextSlice = (data, slice, i) => {
  let result = {
    startTime: "00:00:00",
    endTime: "23:59:59",
  };

  let beforeTimes = data.reduce((acc, item) => {
    if (
      moment(item.info.time.end, "HH:mm").isSameOrBefore(
        moment(slice.info.time.start, "HH:mm")
      )
    ) {
      acc.push(item);
    }
    return acc;
  }, []);
  let afterTimes = data.reduce((acc, item) => {
    if (
      moment(item.info.time.start, "HH:mm").isSameOrAfter(
        moment(slice.info.time.end, "HH:mm")
      )
    ) {
      acc.push(item);
    }
    return acc;
  }, []);

  if (beforeTimes && beforeTimes.length) {
    let sortedBeforeTimes = beforeTimes.sort((x, y) => {
      if (
        moment(x.info.time.start, "HH:mm:ss").isAfter(
          moment(y.info.time.start, "HH:mm:ss")
        )
      ) {
        return 1;
      }
      if (
        moment(x.info.time.start, "HH:mm:ss").isBefore(
          moment(y.info.time.start, "HH:mm:ss")
        )
      ) {
        return -1;
      }
      return 0;
    });
    result.startTime =
      sortedBeforeTimes[sortedBeforeTimes.length - 1].info.time.end;
    result.endTime = "23:59:59"; //sortedBeforeTimes[0].info.time.start
  }
  if (afterTimes && afterTimes.length) {
    let sortedAfterTimes = afterTimes.sort((x, y) => {
      if (
        moment(x.info.time.start, "HH:mm:ss").isAfter(
          moment(y.info.time.start, "HH:mm:ss")
        )
      ) {
        return 1;
      }
      if (
        moment(x.info.time.start, "HH:mm:ss").isBefore(
          moment(y.info.time.start, "HH:mm:ss")
        )
      ) {
        return -1;
      }
      return 0;
    });
    result.endTime = sortedAfterTimes[0].info.time.start;
    if (!(beforeTimes && beforeTimes.length)) {
      result.startTime = "00:00:00";
      //sortedAfterTimes[sortedAfterTimes.length - 1].info.time.end
    }
  }
  console.log("time is wow", result);
  return result;
};
export const showTime = (time, format) => {
  let dateString = getDateString();
  return moment(`${dateString} ${time}`).format(format);
};

// Session reads delegate to utils/loginRedirect.js, which owns the single
// implementation (and is import-light enough for components that must not pull
// this module's editor/segment-tools tree in just to ask "are you signed in?").
// Same answers as before, minus the throw on a corrupted `keyCloak` entry.
export const isUserLoggedIn = () => isSignedIn();
export const getLoggedInUserToken = () => readAuthStore().token;
export const getLoggedInUser = () => readAuthStore().user || null;

// Social-count formatting lives in its own dependency-free module (countFormat.js)
// so it stays unit-testable; re-exported here to preserve the historical
// `helpers.thousandFormatter` import path.
export { thousandFormatter, exactCountLabel } from "./countFormat";
export const calculateAngle = function (x, y) {
  var k = Math.abs(y) / Math.abs(x);
  var angle = (Math.atan(k) * 180) / Math.PI;
  if (y * x > 0) {
    angle = 90 - angle + (y < 0 ? 180 : 0);
  } else {
    angle = angle + (y < 0 ? 90 : 270);
  }

  return angle;
};
export const create_UUID = () => {
  var dt = new Date().getTime();
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      var r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  return uuid;
};

export const getSectionName = (time) => {
  let dateString = getDateString();
  let date = moment(`${dateString} ${time}`);
  if (date.isBefore(moment({ hour: 12, minute: 0 }))) {
    return "Morning";
  } else if (date.isBefore(moment({ hour: 17, minute: 0 }))) {
    return "Midday";
  } else {
    return "Evening";
  }
};
export const prepareWellSectionData = (input) => {
  console.log("prepareWellSectionData :: ", input);
  return input.reduce(
    (acc, item) => {
      console.log("acc: ", acc);
      let activityIndex = acc.findIndex(
        (section) => section.name === item.section_name
      );
      let existingActivity = acc[activityIndex];
      console.log("existingActivity::", existingActivity);
      let modifiedActivityWheel = [...existingActivity.activity_wheel];
      console.log("modifiedActivityWheel: ", modifiedActivityWheel);
      let activityItemIndex = modifiedActivityWheel.findIndex(
        (activity_wheel_item) =>
          activity_wheel_item.unquie_id === item.unquie_id
      );
      let new_item = {
        unquie_id: item.unquie_id,
        title: item?.info?.title,
        text_body: item?.info?.text,
        category: item?.info?.category || 11,
        start_time: item?.info?.time?.start,
        end_time: item?.info?.time?.end,
        activity_tags: [],
        is_locked: false,
        color: item.color || "#C9C4B4",
      };
      if (activityItemIndex > -1) {
        modifiedActivityWheel[activityItemIndex] = new_item;
      } else {
        modifiedActivityWheel.push(new_item);
      }
      let modifiedActivity = {
        name: existingActivity.name,
        activity_wheel: modifiedActivityWheel,
      };
      acc[activityIndex] = modifiedActivity;
      return acc;
    },
    [
      {
        name: "Morning",
        activity_wheel: [],
      },
      {
        name: "Midday",
        activity_wheel: [],
      },
      {
        name: "Evening",
        activity_wheel: [],
      },
    ]
  );
};
export const prepareWellSectionDataEdit = (input, original_wheel_section) => {
  console.log("prepareWellSectionData ::: ", input);
  console.log("original_wheel_section:::", original_wheel_section);
  let new_wheel_section = [];
  for (let i = 0; i < original_wheel_section.length; i++) {
    let obj_original_wheel_section = original_wheel_section[i];
    let obj_new_wheel_section = {};
    obj_new_wheel_section.id = obj_original_wheel_section.id;
    obj_new_wheel_section.activity_wheel = [];
    obj_new_wheel_section.name = obj_original_wheel_section.name;
    input.forEach((user_wheel_section) => {
      if (user_wheel_section.section_id === obj_new_wheel_section.id) {
        let obj_temp_activity_wheel = {};
        obj_temp_activity_wheel.id = user_wheel_section.unquie_id || null;
        obj_temp_activity_wheel.category =
          user_wheel_section?.info?.category || 1;
        obj_temp_activity_wheel.activity_tags = [];
        obj_temp_activity_wheel.created_at =
          obj_original_wheel_section.created_at;
        obj_temp_activity_wheel.updated_at = moment().format(
          "YYYY-MM-DDTHH:mm:sss"
        );
        obj_temp_activity_wheel.title = user_wheel_section?.info?.title || "";
        obj_temp_activity_wheel.text_body =
          user_wheel_section?.info?.text || "";
        obj_temp_activity_wheel.start_time =
          user_wheel_section?.info?.time?.start || "";
        obj_temp_activity_wheel.end_time =
          user_wheel_section?.info?.time?.end || "";

        obj_new_wheel_section.activity_wheel.push(obj_temp_activity_wheel);
        obj_new_wheel_section.name = user_wheel_section.section_name;
      }
      obj_new_wheel_section.activity_wheel.sort(
        (a, b) => moment(a.start_time, "HH:mm") - moment(b.start_time, "HH:mm")
      );
      // else if(!user_wheel_section.section_id &&
      //   user_wheel_section.section_name === obj_original_wheel_section.name){
      //   let obj_temp_activity_wheel = {};
      //  // obj_temp_activity_wheel.id = null;
      //   obj_temp_activity_wheel.category = user_wheel_section?.info?.category || 1;
      //   obj_temp_activity_wheel.activity_tags = [];
      //   obj_temp_activity_wheel.created_at = obj_original_wheel_section.created_at;
      //   obj_temp_activity_wheel.updated_at = moment().format('YYYY-MM-DDTHH:mm:sss');
      //   obj_temp_activity_wheel.title = user_wheel_section?.info?.title || '';
      //   obj_temp_activity_wheel.text_body = user_wheel_section?.info?.text || '';
      //   obj_temp_activity_wheel.start_time = user_wheel_section?.info?.time?.start || '';
      //   obj_temp_activity_wheel.end_time = user_wheel_section?.info?.time?.end || '';

      //   obj_new_wheel_section.activity_wheel.push(obj_temp_activity_wheel);
      //   obj_new_wheel_section.name = user_wheel_section.section_name;
      // }
    });
    new_wheel_section.push(obj_new_wheel_section);
  }
  //for new activity
  input.forEach((user_wheel_section) => {
    if (user_wheel_section.unquie_id.length > 15) {
      //new activity
      let obj_temp_activity_wheel = {};
      // obj_temp_activity_wheel.id = user_wheel_section.unquie_id || null;
      if (user_wheel_section?.info?.category) {
        obj_temp_activity_wheel.category = user_wheel_section?.info?.category;
      }
      obj_temp_activity_wheel.color = user_wheel_section?.color;
      obj_temp_activity_wheel.activity_tags = [];
      obj_temp_activity_wheel.created_at = moment().format(
        "YYYY-MM-DDTHH:mm:sss"
      );
      obj_temp_activity_wheel.updated_at = moment().format(
        "YYYY-MM-DDTHH:mm:sss"
      );
      obj_temp_activity_wheel.title = user_wheel_section?.info?.title || "";
      obj_temp_activity_wheel.text_body = user_wheel_section?.info?.text || "";
      obj_temp_activity_wheel.start_time =
        user_wheel_section?.info?.time?.start || "";
      obj_temp_activity_wheel.end_time =
        user_wheel_section?.info?.time?.end || "";

      //find index of array with same name
      let indexByName = getIndexByName(
        new_wheel_section,
        user_wheel_section.section_name
      );
      let tempObj = {};
      if (indexByName === -1) {
        tempObj = {
          name: "",
          activity_wheel: [],
        };
        tempObj.name = user_wheel_section.section_name;
        tempObj.activity_wheel.push(obj_temp_activity_wheel);
        tempObj.activity_wheel.sort(
          (a, b) =>
            moment(a.start_time, "HH:mm") - moment(b.start_time, "HH:mm")
        );
        new_wheel_section.push(tempObj);
      } else {
        new_wheel_section[indexByName].activity_wheel.push(
          obj_temp_activity_wheel
        );
        new_wheel_section[indexByName].activity_wheel.sort(
          (a, b) =>
            moment(a.start_time, "HH:mm") - moment(b.start_time, "HH:mm")
        );
      }
    }
  });

  console.log("new_wheel_section::", new_wheel_section);
  return new_wheel_section;
};

export const getIndexByName = (arr, name) => {
  let indexArr = -1;
  if (arr.length > 0) {
    arr.forEach((item, index) => {
      if (item.name === name) {
        indexArr = index;
      }
    });
  }
  return indexArr;
};

export const prepareCustomWellSectionData = (input, oldData) => {
  return input.reduce((acc, item, index) => {
    let section = {
      name: oldData[index] ? oldData[index].name : null,
      activity_wheel: [],
    };
    let sections = item?.segments?.map((slice) => {
      let slice_input = {
        title: slice?.title,
        text_body: slice?.text,
        category: slice?.category || 11,
        start_time: "10:00",
        end_time: "11:00",
        activity_tags: [],
        is_locked: false,
        color: item.color || "#C9C4B4",
      };
      return slice_input;
    });
    section.activity_wheel = sections;
    acc.push(section);
    return acc;
  }, []);
};
export const updateCategory = (elem, category) => {
  elem.color = category.color?.color_code;
  elem.outercolor = category.color?.outer_color_code;
  elem.info = { ...elem.info, category: category.id };
  return elem;
};
export const prepareDataForValidation = (
  wheel_data,
  categories,
  categories_outerColor = null
) => {
  let activities = wheel_data.reduce((acc, item) => {
    acc.push(...item.activity_wheel);
    return acc;
  }, []);
  return activities.reduce((acc, item) => {
    let slice = {
      color: categories ? categories[item.category] : "#C9C4B4",
      outerColor: categories_outerColor
        ? categories_outerColor[item.category]
        : categories
        ? categories[item.category]
        : "#C9C4B4",
      percent: getDegreeFromTime(item.start_time, item.end_time),
      inputOffset: calculateOffset(item.end_time),
      label: item.title,
    };
    acc.push(slice);
    return acc;
  }, []);
};
export const prepareDataForValidationEdit = (
  wheel_data,
  categories,
  categoriesOuterColor = null
) => {
  console.log("prepareDataForValidationEdit wheel_data::", wheel_data);
  wheel_data.forEach((wheelData) => {
    let wheel_data_id = wheelData.id;
    wheelData?.activity_wheel.forEach((activityWheel) => {
      activityWheel.wheel = wheelData.wheel || 0;
      activityWheel.name = wheelData.name || "Morning";
      activityWheel.wheelSectionId = wheel_data_id || null;
      // activityWheel.activity_tags = wheelData.activity_tags || [];
    });
  });
  let activities = wheel_data.reduce((acc, item) => {
    acc.push(...item.activity_wheel);
    return acc;
  }, []);
  console.log("activities: ", activities);
  return activities.reduce((acc, item) => {
    console.log("item: ", item);
    let slice = {
      color: categories ? categories[item.category] : "#000",
      outercolor: categoriesOuterColor
        ? categoriesOuterColor[item.category]
        : categories[item.category],
      startTime: item.start_time,
      endTime: item.end_time,
      percent: getDegreeFromTime(item.start_time, item.end_time),
      inputOffset: calculateOffset(item.end_time),
      label: item.title,
      desc: item.text_body,
      id: item.id || 0,
      name: item.name || "",
      wheel: item.wheel || 0,
      category: item.category,
      wheelSectionId: item.wheelSectionId,
      //  activity_tags: item.activity_tags
    };
    acc.push(slice);
    return acc;
  }, []);
};
export const prepareDataForCustomWheel = (
  wheel_data,
  categories,
  categoriesOuterColor
) => {
  return wheel_data.map((item) => {
    item.percent = 100 / wheel_data.length;
    item.segments = item.activity_wheel.map((act) => {
      item.color = categories ? categories[act.category] : "#000";
      item.outerColor = categoriesOuterColor
        ? categoriesOuterColor[act.category]
        : null;
      return act;
    });

    return item;
  });
  // return activities.reduce((acc, item) => {
  //   let slice = {
  //     color: categories ? categories[item.category] : "#000",
  //     percent: getDegreeFromTime(item.start_time, item.end_time),
  //     inputOffset: calculateOffset(item.end_time),
  //     label: item.title
  //   }
  //   acc.push(slice)
  //   return acc
  // }, [])
};
export const shadeColor = (color = "#000000", percent = -10) => {
  var R = parseInt(color.substring(1, 3), 16);
  var G = parseInt(color.substring(3, 5), 16);
  var B = parseInt(color.substring(5, 7), 16);

  R = parseInt((R * (100 + percent)) / 100);
  G = parseInt((G * (100 + percent)) / 100);
  B = parseInt((B * (100 + percent)) / 100);

  R = R < 255 ? R : 255;
  G = G < 255 ? G : 255;
  B = B < 255 ? B : 255;

  R = Math.round(R);
  G = Math.round(G);
  B = Math.round(B);

  var RR = R.toString(16).length == 1 ? "0" + R.toString(16) : R.toString(16);
  var GG = G.toString(16).length == 1 ? "0" + G.toString(16) : G.toString(16);
  var BB = B.toString(16).length == 1 ? "0" + B.toString(16) : B.toString(16);

  return "#" + RR + GG + BB;
};

export const timeToNext5MinSlot = (time) => {
  let arrStart = time.split(":");
  let startMinute = parseInt(arrStart[1]);
  let minuteRemainder = startMinute % 5;
  if (minuteRemainder > 0) {
    startMinute = startMinute + (5 - minuteRemainder);
  }
  if (startMinute === 60) {
    startMinute = 0;
    let startHour = parseInt(arrStart[0]) + 1;
    arrStart[0] = startHour;
  }

  arrStart[1] = startMinute;
  let finalStartTime = arrStart.join(":");
  if (parseInt(arrStart[0]) === 24) {
    finalStartTime = "23:59";
  }

  console.log("finalStartTime:", finalStartTime);

  return finalStartTime;
};

export const getCurrentYear = () => {
  return moment().year();
};

export const getCurrentMonth = () => {
  return moment().month();
};

export const getTimeDiffereceInMinutes = (startTime, endTime) => {
  // let _startTime = moment(startTime, 'mm:SS:sss');
  // let _endTime = moment(endTime, 'mm:SS:sss')

  // return _endTime.diff(_startTime)/1000
  return getTimeDiffereceInMinutesForDragDrop(startTime, endTime);
};

export const getTimeDiffereceInMinutesForDragDrop = (startTime, endTime) => {
  let _startTime = moment(startTime, "HH:mm");
  let _endTime = moment(endTime, "HH:mm");
  let duration = moment.duration(_endTime.diff(_startTime)).as("minutes");
  return duration;
};

export const primaryColorList = [
  "F32A00",
  "F79A00",
  "86BB00",
  "29C18C",
  "F5CC3B",
  "F5CC3B",
  "77CCCD",
  "AAABAD",
  "E25297",
  "99439D",
  "C9C4B4",
];

export const secondaryColorList = [
  "F79781",
  "F8CD80",
  "C4DD81",
  "94DAC1",
  "FFEDAE",
  "8BA6C2",
  "BBE6E7",
  "D6D7D8",
  "E9ADCA",
  "CCA3CF",
  "F0EADB",
];

export const hexToRgb = (hex = "", a = 1) => {
  // Remove the hash at the start if it's there
  hex = hex?.replace(/^#/, "");

  // Parse r, g, b values
  let bigint = parseInt(hex, 16);
  let r = (bigint >> 16) & 255;
  let g = (bigint >> 8) & 255;
  let b = bigint & 255;

  return [r, g, b, a];
};

export function lightenHexColor(hex, percent) {
  if (!hex || !percent) return null;
  // Ensure the percent is within the range of 0 to 100
  percent = Math.min(100, Math.max(0, percent));

  // Convert hex to RGB
  let r = parseInt(hex.substring(1, 3), 16);
  let g = parseInt(hex.substring(3, 5), 16);
  let b = parseInt(hex.substring(5, 7), 16);

  // Calculate the adjustment value
  let adjust = (percent / 100) * 255;

  // Increase each color component by the adjustment value
  r = Math.min(255, r + adjust);
  g = Math.min(255, g + adjust);
  b = Math.min(255, b + adjust);

  // Convert back to hex and return
  return (
    "#" +
    Math.round(r).toString(16).padStart(2, "0") +
    Math.round(g).toString(16).padStart(2, "0") +
    Math.round(b).toString(16).padStart(2, "0")
  );
}

export const getToken = () => {
  const token = JSON.parse(localStorage.getItem("keyCloak") || "{}").token;
  if (token) return token;
  return null;
};

export function parseAVHtmlData(htmlString) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  const links = doc.querySelectorAll("a");
  links.forEach((link) => {
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
    link.style.color = "#0404ee";
  });

  // Handle images
  // const images = doc.querySelectorAll("img");
  // images.forEach((img) => {
  //   img.addEventListener("click", () => alert("Picture"));
  // });

  // Add a custom class to images
  const images = doc.querySelectorAll("img");
  images.forEach((img) => {
    img.classList.add("custom-image-class-for-click");
    img.style.cursor = "pointer";
  });

  const iframes = doc.querySelectorAll("iframe[data-url]");
  iframes.forEach((iframe) => {
    const dataUrl = iframe.getAttribute("data-url");
    const dataType = iframe.getAttribute("data-type");
    let replacement;

    if (dataType.includes("video")) {
      replacement = doc.createElement("video");
      replacement.setAttribute("controls", "controls");
      replacement.setAttribute("src", dataUrl);
      replacement.setAttribute("width", iframe.getAttribute("width"));
      replacement.setAttribute("height", iframe.getAttribute("height"));
      // replacement.setAttribute('type', 'video/mp4');
    } else if (dataType.includes("audio")) {
      replacement = doc.createElement("audio");
      replacement.setAttribute("controls", "controls");
      replacement.setAttribute("src", dataUrl);
      replacement.setAttribute("width", iframe.getAttribute("width"));
      replacement.setAttribute("height", iframe.getAttribute("height"));
    }

    if (replacement) {
      iframe.parentNode.replaceChild(replacement, iframe);
    }
  });

  return doc.body.innerHTML;
}

export function hasAllAlphabets(inputString) {
  if (inputString) {
    const lowerCaseString = inputString.toLowerCase();
    const regex = /^[a-zA-Z\s]*$/;
    return regex.test(lowerCaseString);
  }
}

export function isValidURL(url) {
  const urlPattern =
    /^(https?:\/\/)?([\w-]+\.+[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/;
  return urlPattern.test(url);
}

export function isValidUrlNew(urlString) {
  const pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name and extension
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator
  return !!pattern.test(urlString);
}

export function changeQueryParameters(query, queryObject) {
  Object.entries(queryObject).forEach(([key, value]) => {
    if (value) {
      query.set(key, value);
    } else {
      query.delete(key);
    }
  });
  return query.toString();
}

export function sliderToOpacity(sliderValue) {
  return Number(sliderValue) / 100;
}

export function opacityToSlider(opacity) {
  return Math.floor(((Number(opacity) - 0.1) / 0.9) * 100);
}

export function sliderToPercentage(sliderValue) {
  return `${sliderValue}%`;
}

export function percentageToSlider(percentage) {
  return parseInt(percentage, 10);
}
// export function hexToRgba(hex, opacity) {
//   hex = hex.replace(/^#/, "");
//   let r = parseInt(hex.substring(0, 2), 16);
//   let g = parseInt(hex.substring(2, 4), 16);
//   let b = parseInt(hex.substring(4, 6), 16);
//   return `rgba(${r}, ${g}, ${b}, ${opacity})`;
// }

export function hexToRgba(hex, alpha) {
  // Remove '#' from hex code
  hex = hex.replace(/^#/, "");

  // Convert hex to RGBA
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

function getGradientColors(cssGradient, alpha) {
  if (!cssGradient) return "";
  // Extract hex codes from CSS gradient
  let hexCodes = cssGradient.match(/#[0-9A-Fa-f]{6}/g);

  // Replace hex codes with RGBA
  let gradientWithRgba = cssGradient.replace(/#[0-9A-Fa-f]{6}/g, (match) => {
    return hexToRgba(match, alpha);
  });

  return gradientWithRgba;
}

const hexToRgbConverter = (hex) => {
  const bigint = parseInt(hex.replace(/^#/, ""), 16);
  return {
    r: (bigint >> 16) & 255,
    g: (bigint >> 8) & 255,
    b: bigint & 255,
  };
};

export function applyOpacity(colorValue, opacity) {
  if (!colorValue) return "";
  // Check if the input color value is a hex code
  const isHexCode = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(colorValue);

  if (isHexCode) {
    // If it's a hex code, convert it to RGBA and apply opacity

    const rgbColor = hexToRgbConverter(colorValue);
    return `rgba(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}, ${opacity})`;
  } else {
    return getGradientColors(colorValue, opacity);
    // console.log(colorValue);
    // console.log(opacity);
  }
}

export const isRGBA = (color) => {
  if (!color) return false;
  return /^rgba?\(/.test(color);
};

// fix-gordon-0929-P0-block-pane-header-icons: `icon` is ALWAYS the same tile
// image the Build Menu shows for this block (constants/segmentTools.js
// TILE_ICON_BY_WIDGET_NAME, keyed by the same craft.js resolver name this
// function receives) — never a per-pane hardcoded asset — so the settings
// pane header can never disagree with, or omit, its own Build Menu tile icon.
export const getWidgetDetails = (widgetName) => {
  const icon = TILE_ICON_BY_WIDGET_NAME[widgetName] || null;
  switch (widgetName) {
    case widgetNames.TEXT:
      return { icon, title: "Text Block" };
    case widgetNames.CONTAINER:
      return { icon, title: "Container" };
    case widgetNames.IMAGE:
      return { icon, title: "Image" };
    case widgetNames.DIVIDER:
      return { icon, title: "Divider" };
    case widgetNames.LINKWHEEL:
      return { icon, title: "Link Wheel" };
    case widgetNames.IMAGEGRID:
      return { icon, title: "Image Grid" };
    case widgetNames.IMAGEWITHTEXT:
      return { icon, title: "Image With Text" };
    case widgetNames.SOCIALLINKS:
      return { icon, title: "Social Media Links" };
    case widgetNames.VIDEO:
      return { icon, title: "Video" };
    case widgetNames.DOCUMENT:
      return { icon, title: "Document" };
    case widgetNames.AUDIO:
      return { icon, title: "Audio" };
    case widgetNames.TABLE:
      return { icon, title: "Table" };
    default:
      // QA-46 (Kelly, 2026-07-31): every block added after this switch was
      // written — Carousel, Title Bar, Poll, Form, Graph, Accordion, Button —
      // landed here, and returning `widgetName` verbatim put the INTERNAL craft
      // displayName on screen ("CarouselWidget"). Derive a human label instead
      // of enumerating one more case, so future blocks are covered too.
      return {
        icon,
        title: prettifyWidgetName(widgetName),
      };
  }
};

export const getWallpaperBgColor = (color, opct = 0.5) => {
  const [r, g, b] = hexToRgb(color);
  return `rgba(${r},${g},${b},${opct})`;
};

// ISP-9999 gallery-pill-gif: moved to its own dependency-free module
// (src/utils/caseConvert.js) so code that needs ONLY this pure function
// doesn't have to pull in this file's much heavier transitive graph
// (react-froala-wysiwyg + CSS via CodeBlocks/segmentTools). Re-exported here
// so every existing `import { convertSnakeToCamel } from ".../utils/helpers"`
// (e.g. pages/ViewWheel/index.jsx) keeps working unchanged.
export { convertSnakeToCamel } from "./caseConvert";

function camelToSnake(str) {
  return str.replace(/([A-Z])/g, (letter) => `_${letter.toLowerCase()}`);
}

export function convertKeysToSnakeCase(obj) {
  if (Array.isArray(obj)) {
    return obj.map(convertKeysToSnakeCase);
  } else if (obj !== null && obj !== undefined && obj.constructor === Object) {
    return Object.keys(obj).reduce((acc, key) => {
      const snakeKey = camelToSnake(key);
      acc[snakeKey] = convertKeysToSnakeCase(obj[key]);
      return acc;
    }, {});
  }
  return obj;
}

export const removeHtmlTags = (str = "") => {
  if (!str) return "";
  let cleanStr = str?.replace(/<\/?[^>]+(>|$)/g, "");
  cleanStr = cleanStr?.replace(/&[a-zA-Z]+;/g, "");

  return cleanStr;
};

export const dummyGridImageObject = {
  src: ASSETS.segmentEditor.GridUpload,
  alt: "New image",
  title: "",
  showHyperlink: false,
  hyperlink: null,
};

export function getRandomId() {
  const timestamp = Date.now();
  const randomNum = Math.floor(Math.random() * 1000 + Math.random() * 100);
  return `id-${timestamp}-${randomNum}`;
}

// Moved to its own dependency-free module (./randomBrightColor) so the redux
// reducer layer can use it without importing this barrel — see that file's
// header. Re-exported here so existing component call sites keep working.
export { getRandomBrightColor } from "./randomBrightColor";

export function isBase64Image(str) {
  const base64Pattern = /^data:image\/(png|jpg|jpeg|gif|bmp|webp);base64,/;
  return base64Pattern.test(str);
}

export async function fetchImageAsBase64(imageUrl) {
  try {
    const response = await fetch(imageUrl, {
      method: "GET",  // Explicit GET method
      mode: "cors",   // Ensure CORS is respected
      headers: {
        'Accept': 'image/avif,image/webp,image/apng,image/svg+xml,image/heic,image/*',  // Accept all image types
        'Referer': window.location.href, // Use current page URL as Referer
        'sec-fetch-mode': 'cors',
        'sec-fetch-site': 'cross-site'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result); // Convert to Base64
      reader.onerror = () => reject(new Error("Failed to convert image to base64"));
      reader.readAsDataURL(blob); // Convert image to base64
    });
  } catch (error) {
    console.error("Failed to fetch image:", error);
    return imageUrl; // Fallback to the original URL in case of an error
  }
}


export function transformedText(inputText) {
  if (!inputText) return "";

  const tagPattern = /<\/?[^>]+(>|$)/g;
  const entityPattern = /&[^;]+;/g;

  const htmlEntitiesMap = {
    "&nbsp;": " ",
    "&lt;": "<",
    "&gt;": ">",
    "&amp;": "&",
    "&quot;": '"',
    "&apos;": "'",
  };

  // Replace HTML tags
  let transformedText = inputText.replace(tagPattern, "");

  // Replace HTML entities
  transformedText = transformedText.replace(
    entityPattern,
    (entity) => htmlEntitiesMap[entity] || entity
  );

  // Remove newlines
  transformedText = transformedText.replace(/[\n\r]+/g, "");

  return transformedText || "";
}

// QA-012: single source of truth for the "<name> | iYuga" browser-tab/SEO
// title pattern used by ViewWheel (src/pages/ViewWheel/index.jsx) so other
// pages (e.g. the Segment microsite, src/pages/Segment/index.jsx) can reuse
// the exact same title-generation logic instead of falling back to the
// generic static "iYuga" title from public/index.html.
export function buildIyugaTitle(name) {
  return `${transformedText(name)} | iYuga`;
}

export function isHTMLEmpty(htmlString) {
  const regex = /<([a-z]+)([^>]*)>([\s\S]*?)<\/\1>/gi;
  let match;
  let innermostContent = htmlString;
  while ((match = regex.exec(innermostContent)) !== null) {
    innermostContent = match[3];
  }

  return innermostContent.trim().length === 0;
}

export const getStatusValue = (visibility) => {
  switch (visibility) {
    case 1:
      return "Public";
    case 2:
      return "Private";
    case 3:
      return "Hidden";
  }
};

export const enterFullscreen = () => {
  if (document.documentElement.requestFullscreen) {
    document.documentElement.requestFullscreen();
  } else if (document.documentElement.webkitRequestFullscreen) {
    document.documentElement.webkitRequestFullscreen();
  } else if (document.documentElement.msRequestFullscreen) {
    document.documentElement.msRequestFullscreen();
  }
};

export const exitFullscreen = () => {
  if (document.fullscreenElement) {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  }
};

export function getHexColors(palette) {
  return Object.entries(palette[0])
    .filter(([key, value]) => value.hex)
    .map(([key, value]) => value.hex);
}

export function isValidSuggestedColor(suggestedColorString = "") {
  if (!suggestedColorString) return false;
  return (
    String(suggestedColorString).startsWith("suggested_color") ||
    String(suggestedColorString).startsWith("wheel_suggested_color")
  );
}

export function getSuggestedColor(
  suggestedColorString = "",
  colorArray = [],
  selectedSegmentColor = ""
) {
  if (!colorArray?.length) return null;
  const filteredColor = colorArray?.filter(
    (color) => color !== selectedSegmentColor
  );

  const match = suggestedColorString?.match(/suggested_color_(\d+)/);
  const index = match ? parseInt(match[1], 10) : -1;
  return filteredColor[index] || selectedSegmentColor;
}

export function transformEditorText(inputHtml) {
  if (!inputHtml) return "";
  const tempDiv = document.createElement("div");
  // EW-900 (zero-interaction stored XSS): sanitize the string BEFORE it is parsed
  // into this live-document <div>. Assigning raw user HTML to `.innerHTML` parses it
  // into the live DOM and fires `<img onerror>` (and other resource loaders)
  // IMMEDIATELY — before the post-transform sanitize below could ever strip it. So a
  // segment title / wheel name of `<img src=x onerror=…>` executes on a guest's very
  // first paint of a public wheel. Sanitizing the INPUT first neutralises the handler
  // before any live parse (DOMPurify parses in an inert document that never loads
  // resources). Flag OFF → sanitizeUserHtml is a verbatim passthrough, so this line is
  // byte-identical to the legacy build; the fix only takes effect once the flag is ON.
  tempDiv.innerHTML = sanitizeUserHtml(inputHtml);
  const pElements = tempDiv.querySelectorAll("p");

  if (pElements.length > 1) {
    const firstP = pElements[0];

    for (let i = 1; i < pElements.length; i++) {
      const currentP = pElements[i];

      // Check if currentP only contains <br> elements
      const containsOnlyBr = Array.from(currentP.childNodes).every(
        (node) => node.nodeName === "BR"
      );

      // Only add a <br> if currentP is not just <br> tags
      if (!containsOnlyBr) {
        const br = document.createElement("br");
        firstP.appendChild(br);
      }

      // Move all child nodes from currentP to firstP
      while (currentP.firstChild) {
        firstP.appendChild(currentP.firstChild);
      }

      // Remove the current <p> from the DOM since its content has been moved
      currentP.parentNode.removeChild(currentP);
    }
  }

  // WL-065 (XSS residual): this innerHTML is rendered raw to OTHER viewers via
  // react-contenteditable `<ContentEditable html={...} />` (wheel names/subtitles/
  // descriptions on gallery cards, share modal, primary wheel, mobile views).
  // Sanitize at this shared chokepoint so every caller is covered by construction.
  // Flag-gated (REACT_APP_SANITIZE_HTML, default OFF) → verbatim passthrough until flipped.
  return sanitizeUserHtml(tempDiv.innerHTML);
}
export function transformEditorTextNoStyles(inputHtml) {
  if (!inputHtml) return UNTITLED_WHEEL_NAME;

  const tempDiv = document.createElement("div");
  // EW-900 (zero-interaction stored XSS): sanitize BEFORE the live-DOM parse — see the
  // detailed note in transformEditorText above. Raw `.innerHTML = inputHtml` fires
  // `<img onerror>` on parse, before the post-transform sanitize can run. Flag OFF →
  // verbatim passthrough (byte-identical to legacy); the fix only bites once flag is ON.
  tempDiv.innerHTML = sanitizeUserHtml(inputHtml);

  // Merge multiple <p> tags into one (same logic as in transformEditorText)
  const pElements = tempDiv.querySelectorAll("p");
  if (pElements.length > 1) {
    const firstP = pElements[0];
    for (let i = 1; i < pElements.length; i++) {
      const currentP = pElements[i];
      // Check if currentP only contains <br> elements
      const containsOnlyBr = Array.from(currentP.childNodes).every(
        (node) => node.nodeName === "BR"
      );
      // Only add a <br> if currentP is not just <br> tags
      if (!containsOnlyBr) {
        firstP.appendChild(document.createElement("br"));
      }
      while (currentP.firstChild) {
        firstP.appendChild(currentP.firstChild);
      }
      currentP.remove();
    }
  }

  // Remove inline styles from all elements
  Array.from(tempDiv.querySelectorAll("*")).forEach((node) => {
    node.removeAttribute("style");
  });

  // Remove <font> tags (replace them with their child content)
  const fontTags = tempDiv.querySelectorAll("font");
  fontTags.forEach((fontTag) => {
    while (fontTag.firstChild) {
      fontTag.parentNode.insertBefore(fontTag.firstChild, fontTag);
    }
    fontTag.remove();
  });

  // Check if the content is empty or only whitespace/HTML tags
  const textContent = tempDiv.textContent.trim();
  if (!textContent) {
    return UNTITLED_WHEEL_NAME;
  }

  // WL-065: raw-rendered via ContentEditable html={...} at the same viewer sinks.
  // Sanitize at the chokepoint (flag-gated, default-OFF passthrough).
  return sanitizeUserHtml(tempDiv.innerHTML);
}

export function stripHtmlUsingDOMParser(html) {
  let doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
}

// Block-level tags whose boundaries become line breaks when flattening stored
// rich text (Froala) to plain text for the bio surface.
const HTML_BLOCK_TAGS = new Set([
  "P", "DIV", "BR", "LI", "UL", "OL",
  "H1", "H2", "H3", "H4", "H5", "H6",
  "BLOCKQUOTE", "TR", "SECTION", "ARTICLE", "HEADER", "FOOTER",
]);

/**
 * Flatten a stored rich-text / HTML value to safe PLAIN TEXT for display-only
 * surfaces (wheel titles, profile bio) that render the value as a React text
 * child. Without this, a stored value like `<p>My Wheel</p>` is escaped by React
 * and shown to users as the literal string "<p>My Wheel</p>".
 *
 * XSS-safe BY CONSTRUCTION and independent of REACT_APP_SANITIZE_HTML:
 * DOMParser("text/html") builds an INERT document (no scripts run, no
 * img/iframe subresources load) and we return only textContent. Hostile input
 * such as `<img src=x onerror=alert(1)>` yields "" and `<script>alert(1)</script>`
 * yields the inert text "alert(1)" — neither executes. It never re-injects
 * markup, so it must NOT be swapped for dangerouslySetInnerHTML.
 *
 * @param {string} html raw stored value (plain text or Froala HTML)
 * @param {{ multiline?: boolean }} [opts] multiline=true preserves paragraph /
 *        <br> line breaks (bio); default collapses whitespace to one line (titles)
 * @returns {string} plain text
 */
export function htmlToPlainText(html, { multiline = false } = {}) {
  if (html == null) return "";
  const str = String(html);
  // Plain text with no tags/entities: return as-is (collapsed for titles) so a
  // clean value is never re-processed (no double-escaping).
  if (!/[<&]/.test(str)) {
    return multiline ? str : str.replace(/\s+/g, " ").trim();
  }

  const doc = new DOMParser().parseFromString(str, "text/html");

  if (!multiline) {
    return (doc.body.textContent || "").replace(/\s+/g, " ").trim();
  }

  let out = "";
  const walk = (node) => {
    node.childNodes.forEach((child) => {
      if (child.nodeType === 3 /* TEXT_NODE */) {
        out += child.textContent;
      } else if (child.nodeType === 1 /* ELEMENT_NODE */) {
        if (child.tagName === "BR") {
          out += "\n";
        } else {
          walk(child);
          if (HTML_BLOCK_TAGS.has(child.tagName)) out += "\n";
        }
      }
    });
  };
  walk(doc.body);
  return out.replace(/[ \t]+\n/g, "\n").replace(/\n{3,}/g, "\n\n").trim();
}

// export const mergeAndRemoveDuplicates = (existingArray = [], newArray = []) => {
//   const combinedArray = [...existingArray, ...newArray];
//   const uniqueArray = combinedArray.reduce((acc, current) => {
//     const x = acc.find((item) => item?.id === current?.id);
//     if (!x) {
//       return acc.concat([current]);
//     } else {
//       return acc;
//     }
//   }, []);
//   return uniqueArray;
// };

export const mergeAndRemoveDuplicates = (existingArray = [], newArray = []) => {
  const combinedArray = [...existingArray, ...newArray];
  const uniqueArray = combinedArray.reduce((acc, current) => {
    const existingItemIndex = acc.findIndex((item) => item?.id === current?.id);
    if (existingItemIndex === -1) {
      return acc.concat([current]);
    } else {
      acc[existingItemIndex] = { ...acc[existingItemIndex], ...current };
      return acc;
    }
  }, []);
  return uniqueArray;
};

export const addParam = (obj) => {
  const queryString = Object.entries(obj)
    .reduce((acc, [key, value], index) => {
      if (value !== "" && value !== null) {
        acc.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
      }
      return acc;
    }, [])
    .join("&");

  return queryString ? `?${queryString}` : "";
};

export const extractTextFromHTML = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  return doc.body.textContent || "";
};

export const goToUrl = (link = "") => {
  let url = link.trim();
  if (!url) return;

  // Never navigate to a script-bearing scheme (defence in depth: the https://
  // prefix below already neutralises a bare `javascript:` link, but an explicit
  // guard covers `HTTPS`-cased and whitespace-padded variants).
  if (/^\s*(javascript|data|vbscript|file):/i.test(url)) return;

  if (!/^https?:\/\//i.test(url)) {
    url = `https://${url}`;
  }

  // noopener,noreferrer: the opened page must not gain window.opener access to
  // this tab (reverse-tabnabbing) — required for any user-supplied link target.
  window.open(url, "_blank", "noopener,noreferrer");
};

export const convertInlineStylesToReact = (inlineStyle) => {
  const styleObject = {};

  inlineStyle.split(";").forEach((declaration) => {
    if (!declaration.trim()) return;

    const [property, value] = declaration.split(":");

    if (property && value) {
      const camelCaseProperty = property
        .trim()
        .replace(/-([a-z])/g, (_, char) => char.toUpperCase());

      // Try to parse numbers for specific properties
      const trimmedValue = value.trim();
      styleObject[camelCaseProperty] = isNaN(Number(trimmedValue))
        ? trimmedValue
        : Number(trimmedValue);
    }
  });

  return styleObject;
};

export const extractImagesFromCraftString = (rawString) => {
  try {
    console.log("Raw Input:", rawString);

    // Parse the raw JSON string into an object
    const parsedResponse =
      typeof rawString === "string" ? JSON.parse(rawString) : rawString;

    console.log("Parsed Response:", parsedResponse);

    // Initialize an array to collect images
    const images = [];

    // Traverse through all nodes
    for (const key in parsedResponse) {
      const node = parsedResponse[key];

      // Check for any node with an `image` prop
      if (node?.props?.image) {

        const imageProps = node.props.image;

        // Dynamically extract any possible `src` keys
        const src =
          imageProps.src ||
          imageProps.url ||
          imageProps.thumbnail ||
          imageProps.originalSrc ||
          node.props.src || // Fallback to direct node props
          null;

        const { title = "", url = "", thumbnail = "" } = imageProps;

        if (src) {
          images.push({
            src: src,
            title,
            url,
            thumbnail,
          });
        }
      }

      // Support for ImageGridWidget
      if (
        node?.type?.resolvedName === "ImageGridWidget" &&
        Array.isArray(node?.props?.images)
      ) {
        console.log(
          `ImageGridWidget ${key} contains images:`,
          node.props.images
        );

        node.props.images.forEach((image) => {
          const src =
            image.src ||
            image.url ||
            image.thumbnail ||
            image.originalSrc ||
            null;

          const { url = "", thumbnail = "", id = "" } = image;

          if (src) {
            images.push({
              src,
              url,
              thumbnail,
              id,
            });
          }
        });
      }

      // Support for ImageWithText
      if (node?.type?.resolvedName === "ImageWithText" && node?.props?.image) {


        const imageProps = node.props.image;
        const src =
          imageProps.src ||
          imageProps.url ||
          imageProps.thumbnail ||
          imageProps.originalSrc ||
          null;

        const { title = "", url = "", thumbnail = "" } = imageProps;

        if (src) {
          images.push({
            src,
            title,
            url,
            thumbnail,
          });
        }
      }
    }

    // Deduplicate images by `src`
    const uniqueImages = images.filter(
      (image, index, self) =>
        index === self.findIndex((img) => img.src === image.src)
    );

    return uniqueImages;
  } catch (error) {
    console.error("Error parsing or processing input:", error);
    return [];
  }
};

export const extractVideosFromCraftString = (rawString) => {
  try {
    console.log("Raw Input:", rawString);

    // Parse the raw JSON string
    const parsedResponse =
      typeof rawString === "string" ? JSON.parse(rawString) : rawString;

    console.log("Parsed Response:", parsedResponse);

    // Initialize an array to collect videos
    const videos = [];

    // Traverse through all nodes
    for (const key in parsedResponse) {
      const node = parsedResponse[key];

      // Strictly check if the node is a VideoWidget
      if (node?.type?.resolvedName === "VideoWidget" && node?.props?.src) {
        console.log("Video Found:", node.props);

        const { src, alt, thumbnail, title } = node.props;
        videos.push({
          src: src || null,
          alt: alt || "",
          thumbnail: thumbnail || "",
          title: title || "",
        });
      }
    }

    console.log("Extracted Videos:", videos);
    return videos;
  } catch (error) {
    console.error("Error parsing or processing input:", error);
    return [];
  }
};

export const extractDocumentsFromCraftString = (rawString) => {
  try {
    console.log("Raw Input:", rawString);

    // Parse the raw JSON string
    const parsedResponse =
      typeof rawString === "string" ? JSON.parse(rawString) : rawString;

    console.log("Parsed Response:", parsedResponse);

    // Initialize an array to collect documents
    const documents = [];

    // Traverse through all nodes
    for (const key in parsedResponse) {
      const node = parsedResponse[key];

      // Check if the node is a DocumentWidget and contains documents
      if (
        node?.type?.resolvedName === "DocumentWidget" &&
        Array.isArray(node?.props?.documents)
      ) {
        node.props.documents.forEach((doc) => {
          const { id, src, title, type } = doc;
          documents.push({
            id: id || null,
            src: src || "",
            title: title || "",
            type: type || "",
          });
        });
      }
    }

    console.log("Extracted Documents:", documents);
    return documents;
  } catch (error) {
    console.error("Error parsing or processing input:", error);
    return [];
  }
};

export const extractAudiosFromCraftString = (rawString) => {
  try {
    console.log("Raw Input:", rawString);

    // Parse the raw JSON string
    const parsedResponse =
      typeof rawString === "string" ? JSON.parse(rawString) : rawString;

    console.log("Parsed Response:", parsedResponse);

    // Initialize an array to collect audios
    const audios = [];

    // Traverse through all nodes
    for (const key in parsedResponse) {
      const node = parsedResponse[key];

      // Check if the node is an AudioWidget and contains audios
      if (
        node?.type?.resolvedName === "AudioWidget" &&
        Array.isArray(node?.props?.audios)
      ) {
        node.props.audios.forEach((audio) => {
          audios.push(audio);
        });
      }
    }

    console.log("Extracted Audios:", audios);
    return audios;
  } catch (error) {
    console.error("Error parsing or processing input:", error);
    return [];
  }
};

// ISP-103: derive a short, human-friendly label from a raw URL when a link has
// no explicit name (e.g. a bare URL pasted in a text block). Strips protocol +
// leading "www.", keeps host + first path segment, and truncates so the Hotbar
// shows the "Name of hyperlink, not the URL (too long)".
export const friendlyLinkName = (rawUrl, maxLength = 42) => {
  if (!rawUrl || typeof rawUrl !== "string") return "";
  const s = rawUrl.trim();
  const truncate = (v) =>
    v.length > maxLength ? `${v.slice(0, maxLength - 1)}…` : v;
  try {
    const u = new URL(/^https?:\/\//i.test(s) ? s : `https://${s}`);
    const host = u.hostname.replace(/^www\./i, "");
    const path = (u.pathname || "").replace(/\/+$/g, "");
    const label = path && path !== "/" ? `${host}${path}` : host;
    return truncate(label || s);
  } catch (error) {
    return truncate(s);
  }
};

// ISP-103: returns an array of { name, url } objects (was: an array of raw URL
// strings). `name` is the link's own label where one exists (button title,
// social-platform name, hyperlink caption) and a friendly host+path otherwise;
// `url` keeps the cleaned, openable address. Backward-compatible with existing
// callers because the array LENGTH is unchanged and LinkItem accepts both shapes.
export const extractUrlsFromNodes = (jsonString) => {
  const links = [];

  try {
    // Parse the JSON string into an object
    const parsedData =
      typeof jsonString === "string" ? JSON.parse(jsonString) : jsonString;

    // Helper function to clean and normalize links (the openable URL)
    const cleanLink = (link) =>
      link
        .replace(/<\/?[^>]+(>|$)/g, "") // Remove HTML tags
        .replace(/&amp;/g, "&") // Decode HTML entities
        .trim() // Trim whitespace
        .toLowerCase(); // Convert to lowercase for case-insensitive comparison

    // Clean a candidate display label: strip tags/entities, collapse whitespace.
    const cleanLabel = (raw) =>
      typeof raw === "string"
        ? raw
            .replace(/<\/?[^>]+(>|$)/g, "")
            .replace(/&amp;/g, "&")
            .replace(/\s+/g, " ")
            .trim()
        : "";

    // Push a link with a name, falling back to a friendly URL label.
    const pushLink = (rawUrl, rawName) => {
      const url = cleanLink(rawUrl);
      if (!url) return;
      const label = cleanLabel(rawName);
      links.push({ name: label || friendlyLinkName(url), url });
    };

    // Traverse through all nodes to find relevant components
    for (const key in parsedData) {
      const node = parsedData[key];

      // Check for nodes with showHyperlink === true and extract hyperlink
      if (node?.props?.showHyperlink && node?.props?.hyperlink) {
        // ImageWithText hyperlinks carry a caption in `text`; use it as the name.
        pushLink(node.props.hyperlink, node?.props?.text);
      }

      // Additional link extraction logic for other node types (if necessary)
      if (
        node?.type?.resolvedName === "Buttons" &&
        Array.isArray(node?.props?.allButtons)
      ) {
        node.props.allButtons.forEach((button) => {
          if (button?.link) {
            pushLink(button.link, button?.title ?? button?.text ?? button?.label);
          }
        });
      }

      if (node?.type?.resolvedName === "TextWidget" && node?.props?.text) {
        const text = node.props.text;
        const urlMatches = text.match(/https?:\/\/[^\s"]+/g);
        if (urlMatches) {
          urlMatches.forEach((m) => pushLink(m));
        }
      }

      if (node?.type?.resolvedName === "ImageWithText" && node?.props?.text) {
        const text = node.props.text;
        const urlMatches = text.match(/https?:\/\/[^\s"]+/g);
        if (urlMatches) {
          urlMatches.forEach((m) => pushLink(m));
        }
      }

      if (
        node?.type?.resolvedName === "SocialLinksWidget" &&
        Array.isArray(node?.props?.socialLinks)
      ) {
        node.props.socialLinks.forEach((socialLink) => {
          if (socialLink?.link && socialLink.isLinkValid) {
            pushLink(
              socialLink.link,
              socialLink?.platform ?? socialLink?.name ?? socialLink?.title
            );
          }
        });
      }
    }
  } catch (error) {
    console.error("Error parsing JSON or extracting links:", error);
  }

  // Deduplicate by URL, keeping the first (named) occurrence.
  const seen = new Set();
  const uniqueLinks = [];
  for (const item of links) {
    if (seen.has(item.url)) continue;
    seen.add(item.url);
    uniqueLinks.push(item);
  }

  return uniqueLinks;
};

export const extractItemsFromSegments = (segments) => {
  return segments.map((segment) => {
    const { nodes, id } = segment;
    const { title } = segment?.settings;

    // Parse nodes JSON string. `nodes` sometimes arrives already parsed (e.g.
    // the Wheel Builder's own loader pre-parses it into an object before this
    // runs - see pages/SegmentBuilder/index.jsx), so guard like every other
    // JSON.parse(nodes) call site in this codebase already does (and like the
    // ViewWheel copy of this function). Un-guarded, JSON.parse(object) throws
    // "'[object Object]' is not valid JSON" and the {} fallback silently drops
    // all of that segment's media from the Hotbar tabs.
    let parsedNodes = nodes;
    try {
      parsedNodes = typeof nodes === "string" ? JSON.parse(nodes) : nodes;
    } catch (error) {
      console.error("Error parsing nodes JSON:", error);
    }

    // Extract items
    const images = extractImagesFromCraftString(parsedNodes);
    const videos = extractVideosFromCraftString(parsedNodes);
    const audios = extractAudiosFromCraftString(parsedNodes);
    const documents = extractDocumentsFromCraftString(parsedNodes);
    const links = extractUrlsFromNodes(parsedNodes);

    return {
      title,
      items: {
        images,
        videos,
        audios,
        documents,
        links,
      },
      // T22.180: the swatch follows the Segment Fill the wedge paints (a
      // gradient/pattern/image fill), not the stale base colour.
      segmentColor: hotbarSegmentSwatch(segment),
      segmentId: id,
    };
  });
};

export const handleDownloadImage = async (imageUrl) => {
  try {
    // Fetch the image as a blob
    const response = await fetch(imageUrl);
    const blob = await response.blob();

    // Create a URL for the blob
    const blobUrl = URL.createObjectURL(blob);

    // Create an anchor element for the download
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = "image.jpg"; // Set the file name
    document.body.appendChild(link);

    // Trigger the download
    link.click();

    // Clean up the blob URL and remove the anchor
    URL.revokeObjectURL(blobUrl);
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading the image:", error);
  }
};

export function htmlToText(htmlString) {
  // EW-900 (stored XSS, SECOND sink — measured live on main.97a94ff1.js):
  // parse in an INERT DOMParser document instead of a live-document <div>. The old
  // `div.innerHTML = htmlString` parsed attacker markup into the LIVE document, firing
  // `<img onerror>` / `<... onload>` resource loaders IMMEDIATELY. That runs on a guest's
  // first paint of a public /wheel/:id: CommandPaletteRoot is mounted app-wide (App.js)
  // and its buildSegments/wheelToItem useMemo (NOT gated by the palette being open) calls
  // htmlToText(segment.title | wheel_name) on index. A DOMParser document has no browsing
  // context and is never inserted into the live tree, so no resource loads and no handlers
  // fire. Plain-text output is byte-identical to the old textContent for benign input.
  // UNCONDITIONAL (pure hardening, output-preserving) — gating behind a default-OFF flag
  // would leave prod vulnerable. Rollback = revert the commit.
  if (htmlString == null) return "";
  const doc = new DOMParser().parseFromString(String(htmlString), "text/html");
  return doc.body?.textContent || "";
}

// Single source of truth for the empty-wheel-name fallback. Every surface that
// renders a wheel's name (gallery grid, gallery list, builder Segment Library,
// name-field placeholder) must resolve an empty/whitespace/tags-only name to
// this exact label so the surfaces never disagree.
export const UNTITLED_WHEEL_NAME = "Untitled Wheel";

// Returns a plain-text display name for a wheel, falling back to
// UNTITLED_WHEEL_NAME when the stored name is empty or only markup/whitespace.
export function getWheelDisplayName(rawName) {
  // Guard nullish first: setting innerHTML = undefined/null coerces to the
  // literal string "undefined"/"null", which would render as a bogus name.
  if (rawName == null || rawName === "") return UNTITLED_WHEEL_NAME;
  const text = htmlToText(rawName)?.trim();
  return text || UNTITLED_WHEEL_NAME;
}

export function isCardExpired(expiryMonth, expiryYear) {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;
  const currentYear = currentDate.getFullYear();

  if (expiryYear < currentYear) {
    return true;
  } else if (expiryYear === currentYear && expiryMonth < currentMonth) {
    return true;
  }

  return false;
}
